import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const ProductCardSwatchesImage = t0 => {
  const $ = _c(3);
  const {
    src,
    label: t1
  } = t0;
  const label = t1 === undefined ? "" : t1;
  if (!src) {
    return null;
  }
  const t2 = `${src}?auto=format%2Ccompress&fit=crop&crop=entropy&h=20&w=20&cs=srgb`;
  let t3;
  if ($[0] !== label || $[1] !== t2) {
    t3 = <img alt={label} height={20} src={t2} width={20} />;
    $[0] = label;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
ProductCardSwatchesImage.propTypes = {
  label: PropTypes.string,
  src: PropTypes.string
};
const ProductCardSwatchesImageMemo = React.memo(ProductCardSwatchesImage);
export default ProductCardSwatchesImageMemo;